module.exports = __webpack_public_path__ + "static/media/transition-screen-chanukiah-bg.982f7934.png";